'use client';

import React, { useEffect, useState } from 'react';
import classes from '@/components/shop/shop-detail-home.module.scss';
import { convertDatetimeToString } from '@/lib/convert-datetime';
import { IShop } from '@/schema/shop';

function ShopDetailInfoDate({
  shop,
  dict: { purchasePeriod, deliveryAtNotice, shippingAfter },
}: {
  shop: IShop;
  dict: {
    purchasePeriod: string;
    deliveryAtNotice: string;
    shippingAfter: string;
  };
}) {
  const [startAt, setStartAt] = useState<string | null>(null);
  const [endAt, setEndAt] = useState<string | null>(null);
  const [deliveryAt, setDeliveryAt] = useState<string | null>(null);

  useEffect(() => {
    if (shop) {
      setStartAt(shop.startAt);
      setEndAt(shop.endAt);
      setDeliveryAt(shop.deliveryAt);
    }
  }, [shop]);
  return (
    <>
      <div className={classes.conItem}>
        {purchasePeriod} :{' '}
        {startAt !== null && convertDatetimeToString(startAt, true)} ~{' '}
        {endAt !== null && convertDatetimeToString(endAt, true)}
      </div>
      <div className={classes.conItem}>
        {deliveryAtNotice} :{' '}
        {deliveryAt !== null &&
          shippingAfter.replace(
            '{date}',
            convertDatetimeToString(deliveryAt, true, false),
          )}
      </div>
    </>
  );
}

export default ShopDetailInfoDate;
